import React, { useState } from "react";

import Button from "components/Button";
import PDF_Export_Drawer from "../Drawer";

import classes from "./styles.module.scss";

import Export from "assets/images/icons/JSX/Export";

const PDF_Export_Button = ({
    results = {},
    displayUnits = "Metric",
    disabled = false,
}) => {
    const [exporting, toggleExporting] = useState(false);
    const [isPdfExportOpen, setIsPdfExportOpen] = useState(false);

    const handleExport = async () => {
        toggleExporting(true);
        setIsPdfExportOpen(true);
        toggleExporting(false);
    };

    return (
        <div className={classes.pdfExportButtonContainer}>
            <Button
                onClick={handleExport}
                disabled={exporting || disabled}
                icon={Export}
                className={classes.exportButton}
            >
                {exporting ? "Downloading..." : "Download Report"}
            </Button>
            <PDF_Export_Drawer
                isPdfExportOpen={isPdfExportOpen}
                handleClose={() => setIsPdfExportOpen(false)}
                results={results}
                displayUnits={displayUnits}
            />
        </div>
    );
};

export default PDF_Export_Button;